export const PurchaseStatuses = ['Initialized', 'Completed', 'Error', 'Cancelled']

export const deviceNumberRegex = /^[0-9]{3}-[0-9]{3}$/